import script from "./CertificateRedirect.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificateRedirect.vue?vue&type=script&setup=true&lang=js"

import "./CertificateRedirect.vue?vue&type=style&index=0&id=5e5ee080&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e5ee080"]])

export default __exports__